import {useEffect, useMemo, useState} from "react";
import {useRestClient} from "../client/SpmRestClient";
import {Spinner} from "react-bootstrap";
import {ContactSource} from "../types/ContactSource";
import {GenericSelectOption, StringSelect} from "zavadil-react-common";
import {useAlerts} from "../utils/UserAlerts";

export type SelectContactSourceProps = {
	sourceId?: string | null;
	onChange(sourceId?: string | null): any;
}

export default function SelectContactSource({sourceId, onChange}: SelectContactSourceProps) {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [contactSources, setContactSources] = useState<Array<ContactSource>>();

	useEffect(() => {
			restClient.contactSources.all()
				.then(setContactSources)
				.catch((e) => userAlerts.err(e));
		},
		[]
	);

	const options: GenericSelectOption<string>[] = useMemo(
		() => contactSources ? contactSources.map(
			(cs) => {
				return {
					id: cs.id,
					label: cs.name
				}
			}) : [],
		[contactSources]
	);

	return contactSources ? <StringSelect
		options={options}
		value={sourceId}
		onChange={onChange}
		showEmptyOption={true}
	/> : <Spinner/>
}
